export class MeshSprite3DShaderDeclaration {
}
